/**
 * CompareDelta — compact base-vs-scenario delta table posted into the chat after
 * a scenario run completes. Full detail lives on the Compare screen.
 */
const fmt = (n, unit) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  if (unit === "pct") return `${(n * 100).toFixed(2)}%`;
  if (unit === "count") return Math.round(n).toLocaleString();
  const a = Math.abs(n);
  return a >= 1e6 ? `${(n / 1e6).toFixed(2)}M` : a >= 1e3 ? `${(n / 1e3).toFixed(1)}K` : n.toFixed(2);
};

const deltaColor = (d) =>
  d > 0 ? "#1B7A4A" : d < 0 ? "#A61B2B" : "var(--ev-text-muted)";

const CompareDelta = ({ compare }) => {
  const metrics = (compare?.metrics || []).filter(
    (m) => m.base !== 0 || m.scenario !== 0
  );
  if (metrics.length === 0)
    return (
      <div style={{ fontSize: "0.75rem", color: "var(--ev-text-muted)", fontStyle: "italic" }}>
        No comparable metrics yet.
      </div>
    );

  return (
    <div
      style={{
        border: "1px solid var(--ev-border)",
        borderRadius: "8px",
        overflow: "hidden",
        fontSize: "0.72rem",
      }}
    >
      <table className="table is-fullwidth is-narrow" style={{ marginBottom: 0, fontSize: "0.72rem" }}>
        <thead>
          <tr>
            <th style={{ fontSize: "0.66rem" }}>Metric</th>
            <th style={{ fontSize: "0.66rem", textAlign: "right" }}>Original</th>
            <th style={{ fontSize: "0.66rem", textAlign: "right" }}>Scenario</th>
            <th style={{ fontSize: "0.66rem", textAlign: "right" }}>Δ%</th>
          </tr>
        </thead>
        <tbody>
          {metrics.map((m) => (
            <tr key={m.key}>
              <td style={{ whiteSpace: "nowrap" }}>{m.label}</td>
              <td style={{ textAlign: "right", whiteSpace: "nowrap" }}>{fmt(m.base, m.unit)}</td>
              <td style={{ textAlign: "right", whiteSpace: "nowrap" }}>{fmt(m.scenario, m.unit)}</td>
              <td style={{ textAlign: "right", whiteSpace: "nowrap", color: deltaColor(m.delta), fontWeight: 600 }}>
                {m.deltaPct === null || m.deltaPct === undefined
                  ? "—"
                  : `${m.deltaPct > 0 ? "+" : ""}${m.deltaPct}%`}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {compare?.missing?.length > 0 && (
        <div style={{ padding: "0.3rem 0.5rem", color: "var(--ev-text-muted)", fontSize: "0.66rem" }}>
          Not available: {compare.missing.join(", ")}
        </div>
      )}
    </div>
  );
};

export default CompareDelta;
